// extracted by mini-css-extract-plugin
export default {"file-selector":"FileInput_file-selector__B3XSa"};